import React, { useState, useEffect } from 'react';
import Dropzone from "react-dropzone";
import { Card, Row, Col, Label } from 'reactstrap';
import { Link } from "react-router-dom";
import { ErrorMessage } from "formik";
import apiGlobal from '../../global/api.global';
import { formatBytes } from 'GenericForms/Helper';
import { useDispatch } from 'react-redux';
import { setFlags } from "../../Store/Generic/GenericSlice";

interface Props {
    name: string;
    type: string;
    placeholder?: string;
    [x: string]: any
}

const CustomImgUpload = (props: Props) => {
    const [selectedFiles, setselectedFiles] = useState<any>([]);
    const [csrf, setCSRF] = useState<any>()
    const dispatch = useDispatch()

    useEffect(() => {
        const loadCSRFToken = async () => {
            apiGlobal.get(`get-csrf-token`,
            ).then(res => {
                setCSRF(res.data);
            })
                .catch(err => {
                    console.log(err);
                });
        }; loadCSRFToken();
    }, []);

    function handleAcceptedFiles(files: any) {
        files.map((file: any) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            })
        );
        dispatch(setFlags(files));
        setselectedFiles(files);
    }

    return (
        <>
            <Label htmlFor={props.name || props.id}> {props.placeholder} </Label>
            <Dropzone
                onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles);
                }}
                accept={{
                    'image/jpeg': [],
                    'image/png': []
                }}
            >
                {({ getRootProps, getInputProps }) => (
                    <>
                        <div className="dropzone">
                            <div
                                className="dz-message needsclick mt-2"
                                {...getRootProps()}
                            >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                    <i className="display-4 text-muted bx bx-cloud-upload" />
                                </div>
                                <h4>Click here to upload</h4>
                            </div>
                        </div>
                        <ErrorMessage name={props.name} component="span" className="error" />
                    </>
                )}
            </Dropzone>
            <div className="dropzone-previews mt-3" id="file-previews">
                {selectedFiles.map((f: any, i: number) => {
                    return (
                        <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                        >
                            <div className="p-2">
                                <Row className="align-items-center">
                                    <Col className="col-auto">
                                        <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                        />
                                    </Col>
                                    <Col>
                                        <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                        >
                                            {f.name}
                                        </Link>
                                        <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    )
                }
                )}
            </div>
        </>
    )
}

export default CustomImgUpload;